import {
  AdminSiteManagement,
  UserSiteManagement,
} from 'pages/sites/components';

import { useCanAccess } from 'hooks/useCanAccess';
import { Unauthorized } from 'components/unauthorized';
import { TokenExpired } from 'components/tokenExpired';

export const SiteManagementRoute = () => {
  const { canAccess, isAdmin, isExpired } = useCanAccess('sites');

  return isExpired ? (
    <TokenExpired />
  ) : isAdmin ? (
    <AdminSiteManagement />
  ) : canAccess ? (
    <UserSiteManagement />
  ) : (
    <Unauthorized />
  );
};
